export const environmentBase = {
  TSI_SOPORTE:'url_soporte',
  TSI_SOPORTE_PRUEBA:'url_soporte'
}